import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card border-0 shadow-none rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4 p-xl-40" }
const _hoisted_3 = { class: "toolbar-card mb-4" }
const _hoisted_4 = { class: "toolbar-left" }
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = { class: "text-muted mb-0" }
const _hoisted_7 = { class: "toolbar-right" }
const _hoisted_8 = { class: "search-shell" }
const _hoisted_9 = ["value", "placeholder"]
const _hoisted_10 = {
  key: 0,
  class: "image-thumb-wrap"
}
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = {
  key: 1,
  class: "code-pill"
}
const _hoisted_13 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_14 = {
  key: 4,
  class: "d-flex justify-content-center gap-2"
}
const _hoisted_15 = ["title", "onClick"]
const _hoisted_16 = ["title", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("category_page.list_title")), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("category_page.list_description")), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("input", {
              value: _ctx.searchQuery,
              type: "text",
              class: "form-control toolbar-search",
              placeholder: _ctx.$t('category_page.search_placeholder'),
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:searchQuery', ($event.target as HTMLInputElement).value)))
            }, null, 40, _hoisted_9),
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ri-search-line search-icon" }, null, -1))
          ]),
          _createElementVNode("button", {
            class: "btn style-one btn-sm d-flex align-items-center gap-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('create')))
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ri-add-circle-line" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("category_page.create_button")), 1)
          ])
        ])
      ]),
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        "data-source": _ctx.categories,
        "row-key": 'id',
        pagination: _ctx.paginationConfig,
        locale: { emptyText: _ctx.$t('category_page.no_categories_found') },
        class: "category-table"
      }, {
        bodyCell: _withCtx(({ column, record, text }) => [
          (column.key === 'image')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("img", {
                  src: _ctx.getImageUrl(record.image),
                  alt: _ctx.$t('category_page.category_image_alt'),
                  class: "image-thumb"
                }, null, 8, _hoisted_11)
              ]))
            : (column.key === 'code')
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(text || _ctx.$t("category_page.not_available")), 1))
              : (column.key === 'description')
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(text || _ctx.$t("category_page.no_description")), 1))
                : (column.key === 'status')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 3,
                      class: _normalizeClass(["status-badge", Number(record.status ?? 1) === 1 ? 'status-active' : 'status-inactive'])
                    }, _toDisplayString(Number(record.status ?? 1) === 1 ? _ctx.$t("category_page.status_active") : _ctx.$t("category_page.status_inactive")), 3))
                  : (column.key === 'actions')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("button", {
                          class: "icon-btn",
                          title: _ctx.$t('category_page.edit'),
                          onClick: ($event: any) => (_ctx.$emit('edit', record))
                        }, [...(_cache[4] || (_cache[4] = [
                          _createElementVNode("i", { class: "ri-pencil-line" }, null, -1)
                        ]))], 8, _hoisted_15),
                        _createElementVNode("button", {
                          class: "icon-btn danger",
                          title: _ctx.$t('category_page.delete'),
                          onClick: ($event: any) => (_ctx.$emit('delete', record))
                        }, [...(_cache[5] || (_cache[5] = [
                          _createElementVNode("i", { class: "ri-delete-bin-6-line" }, null, -1)
                        ]))], 8, _hoisted_16)
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                        _createTextVNode(_toDisplayString(text || _ctx.$t("category_page.not_available")), 1)
                      ], 64))
        ]),
        _: 1
      }, 8, ["columns", "data-source", "pagination", "locale"])
    ])
  ]))
}